<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
         <v-toolbar dense dark color="secondary">NEW PURCHASE<v-spacer/><v-icon @click="emitToParent('cancel')">mdi-close</v-icon> </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                v-model="po.number"
                prepend-icon="mdi-file"
                label="P.O #"
                :rules="textRules"
                dense
                outlined
                required
                ></v-text-field>
                <v-autocomplete
                   v-model="supplier"
                label="Supplier"
                prepend-icon="mdi-card-account-details-star"
                :items="$store.state.suppliers"
                item-text="company"
                item-value="id"
                :rules="textRules"
                return-object
                dense
                outlined
                required
                />
                 <v-text-field
                v-model="supplier.person"
                prepend-icon="mdi-account"
                label="Contact Person"
                dense
                outlined
                ></v-text-field>
                 <v-text-field
                v-model="supplier.number"
                 prepend-icon="mdi-phone"
                label="Contact #"
                dense
                outlined
                ></v-text-field>
                <v-autocomplete
                   v-model="po.truck"
                    prepend-icon="mdi-truck"
                label="Truck"
                :items="$store.state.trucks"
                item-text="name"
                item-value="id"
                dense
                outlined
                />

                <v-autocomplete
                  v-model="po.driver"
                   prepend-icon="mdi-badge-account-horizontal-outline"
                  label="Driver"
                  :items="DRIVERS"
                  item-text="fullname"
                  item-value="id"
                  dense
                  outlined
                />

             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small  text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
       po:{},
        supplier:{},
        suppliers:[]
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      DRIVERS() {
        if(this.$store.state.drivers == undefined || this.$store.state.drivers == null) {
          return []
        }
        var arr = this.$store.state.drivers.reduce((res, item)=>{
            if(item.status=='active') {
              res.push(item)
            }
            return res
        },[])
        return arr
      },
  },
  watch: {
    
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.po.supplier = this.supplier.id 
          this.po.status = 'on-process'
          this.Save()
        }
      },
    emitToParent (action) {
       this.$emit('DialogEvent', {action: action, po:this.po})
    },
    Save() {
        this.$http.post("purchase/add", this.po).then(response => {
            response.data.status?this.VA_ALERT("success", response.data.message):this.VA_ALERT("error", response.data.message)
           this.$emit('DialogEvent', {action: "closer", po:{}})
          }).catch(e => {
            console.log(e.data)
        })
    }
  }
}
</script>
